import {
    all,
    takeLatest,
    put
} from 'redux-saga/effects'
import {
    VALIDATE_ACTION
} from './constants'
import {
    setStepRedirectAction,
    setIsLoggedInAction,
    setReferral,
    setPreviewData
} from './accions'
import {
    addMailAction,
    saveTypeCompany
} from '../Step1/accions'

import { cleanStore } from '../../localStore'

//const airbase = require('../../utils/airtable').base('appzL6pfzYhxOdwsg'); dev
const airbase = require('../../utils/airtable').base(process.env.airtableApiKey);

function* validateSaga(action) {
    try {
        let message = 'done'
        let redirect = ''
        let email = ''
        let company = ''
        let referral = ''
        let previewData = {
            nombreCompleto: '',
            telefono: ''
        }
        yield airbase.table('Clientes')
            .selectOneByFormula('solicitudId="' + action.payload.solicitudId + '"')
            .then(async function (clientRecord) {
                if (clientRecord) {
                    redirect = `/step${clientRecord.fields.Step}`
                    email = clientRecord.fields.Email
                    company = clientRecord.fields.Tipo
                    referral = clientRecord.fields.Referral
                    previewData.nombreCompleto = clientRecord.fields.Nombre
                    previewData.telefono = clientRecord.fields.Telefono
                } else {
                    await airbase.table('Clientes') // puede ser que venga del login con un mail y sin idSolicitud
                        .selectOneByFormula('Email="' + action.payload.email + '"')
                        .then(function (clientRecord) {
                            if (clientRecord) {
                                redirect = `/step${clientRecord.fields.Step}`
                                email = clientRecord.fields.Email
                                company = clientRecord.fields.Tipo
                                referral = clientRecord.fields.Referral
                                previewData.nombreCompleto = clientRecord.fields.Nombre
                                previewData.telefono = clientRecord.fields.Telefono
                            } else {
                                // esto es si viene con un idSolicitud erroneo
                                return window.location.replace(window.location.origin + '/credility/login/')
                            }
                        })
                }
            })

        if (message === 'done') {
            console.log(email);

            yield put(setStepRedirectAction(redirect))

            yield put(addMailAction(email))

            yield put(setPreviewData(previewData))

            yield put(setIsLoggedInAction(true))

            yield put(saveTypeCompany(company))

            yield (put(setReferral(referral)))
        }

    } catch (err) {
        console.log(err);
    }
}

function* watchValidate() {
    yield takeLatest(VALIDATE_ACTION, validateSaga)
}

export default function* loginSaga() {
    yield all([
        watchValidate()
    ]);
}


// WEBPACK FOOTER //
// ./src/conteiners/Callback/sagas.js